module.exports = __webpack_public_path__ + "static/media/vowels_img.349e17a4.JPG";